module.exports = __webpack_public_path__ + "static/media/scientific-articles-recommendation.16842406.webp";